import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {auth} from './auth';
import {bind} from './bind';
import {register} from './register';
import {notification} from './notification';
import {order} from './order';
import {userCenter} from './userCenter';
import {myOrder} from './myOrder';
import {host} from './host';
import {customer} from './customer';
import {localData} from './localData';
import {replenishment} from './replenishment';
import {inventoryQuery} from './inventoryQuery';
import {applyListing} from './applyListing';
import {stManagement} from './stManagement';
import {allApply} from './allApply';
import {noScOrder} from './noScOrder';
import {ltoPurchaseOrder} from './ltoPurchaseOrder';
import {taskManagement} from './taskManagement';
import {proxyDelivery} from './proxyDelivery';

const rootReducer = combineReducers({
    routing: routerReducer,
    auth,
    notification,
    order,
    bind,
    register,
    userCenter,
    myOrder,
    host,
    customer,
    localData,
    replenishment,
    inventoryQuery,
    stManagement,
    applyListing,
    allApply,
    noScOrder,
    ltoPurchaseOrder,
    taskManagement,
    proxyDelivery,
});

export default rootReducer;
